import fraseDoktorLogo from "../../assets/brands/Loge_FraseDoktor.svg";

export default function FraseDoktor() {
  return (
    <section className="container mt-16 doctio-grey-border mx-auto">
      <div className="flex flex-col pt-16 border-t items-center justify-center md:flex-row  mx-auto">
        <div className="mr-0 md:pr-40 md:mx-auto flex-1 h-min w-100">
          <img
            src={fraseDoktorLogo}
            alt="Frasedoktor logo"
            className="w-10/12 mx-auto md:w-full"
          />
        </div>
        <div className="mx-auto mt-16 md:mt-0 flex-1 lg:flex">
          <div className="max-w-full overflow-hidden">
            <span className="tracking-[1px] mb-2 leading-[1.2] text-dbase font-medium">
              DOCTIO’S HISTORIE
            </span>

            <h2 className="md:max-w-none text-dxl mb-10 md:text-[25px] mb-0 font-bold text-doctio-green">
              Det begyndte som frasedoktor
            </h2>

            <p className="font-bold mt-0 mb-8">Et klinisk værktøj</p>

            <p className="max-w-2xl md:max-w-none  font-medium">
              Doctio kom til verden baseret på et mål om at skabe et godt
              klinisk værktøj, der kunne optimere journalføringen samt
              understøtte og vejlede behandleren, og dermed sikre patienten den
              bedst mulige behandling. Hverken mere eller mindre. Et klinisk
              værktøj der var simpelt at bruge og af høj faglighed og kvalitet.
              “Frasedoktor” kaldte vi det. For det var det, det var. Fraser, der
              i alt sin enkelthed fungerede
            </p>

            <p className="max-w-2xl md:max-w-none  font-medium">
              Siden da er navnet skiftet til Doctio, og platformen er vokset.
              Fraserne består, men de har fået følgeskab af flere
              funktionaliteter, der gør Doctio til et endnu bedre klinisk
              værktøj. Klikelementer, dynamisk fraser med logikker der følger
              NBV’er, delefunktioner, DoctioAssist med autosuggestion og meget
              meget mere. Filosofien er dog den samme, og det bliver den ved med
              at være. Doctio handler om at optimere journalføringen,
              understøtte behandleren og højne behandlingskvaliteten for
              patienterne.{" "}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
